import React from "react";

const PerformanceReport = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg width={size} style={style} height={size} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg"
         className={`${className || ""}`} xmlnsXlink="http://www.w3.org/1999/xlink">
        <path
            className="u_fill"
            d="M11.2 22.4c0-1.293.506-2.534 1.406-3.448A4.763 4.763 0 0 1 16 17.524c1.273 0 2.494.514 3.394 1.428A4.916 4.916 0 0 1 20.8 22.4h-9.6Zm4.8-5.486c-1.989 0-3.6-1.636-3.6-3.657 0-2.02 1.611-3.657 3.6-3.657s3.6 1.637 3.6 3.657-1.611 3.657-3.6 3.657Z"
            fill={fill}
        />
        <path
            className="u_fill"
            d="M32 16a16 16 0 1 1-9.723-14.717l-2.206 5.17A10.379 10.379 0 1 0 26.38 16H32Z"
            fill={fill}
        />
        <path
            className="u_fill"
            d="M26.308 3.763a16 16 0 0 1 5.226 8.404l-5.457 1.347a10.38 10.38 0 0 0-3.39-5.452l3.62-4.3Z"
            fill={fill}
        />
    </svg>
);

export default PerformanceReport;
